export const InternalServerErrorMessage =
    'Oops! Internal server error Please try refreshing the page. If the issue persists, please reach out to us at support@acko.com';

export const ERROR_403 =
    'You can not view the policy because you are logged in from a different phone number. \n Please login from your number registered with ACKO to access this policy';
export const ERROR_404 =
    'Uh oh! The page you are trying to access could not be found. Please check the link and try again';
export const ERROR_500 =
    'Oops! Internal server error \n Please try refreshing the page. If the issue persists, please reach out to us at support@acko.com';
